interface MetaTag {
  name?: string
  property?: string
  content?: string | undefined
}

/** Replace the CMS default without emitting competing og:type tags. */
export function withOpenGraphType(tags: Array<MetaTag | null>, type: 'article' | 'website'): MetaTag[] {
  return [
    ...tags.filter((tag): tag is MetaTag => tag !== null && tag.property !== 'og:type' && tag.name !== 'og:type'),
    { property: 'og:type', content: type },
  ]
}
